import { t } from '../strings/i18n';
const allFieldRequiredInstruction = 'label.allFieldRequiredInstruction';
const getAutopayIntroHeading = (isSelectAutopayPaymentMethodMessage) => {
    if (isSelectAutopayPaymentMethodMessage) {
        return `${t('autopay.selectAutopayPaymentMethod')} ${t(allFieldRequiredInstruction)}`;
    }
    return `${t('autopay.selectAutopayAmountAndPaymentMethod')} ${t(allFieldRequiredInstruction)}`;
};
export default getAutopayIntroHeading;
